import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8h4v6a2 2 0 1 1 -4 0","key":"svg-0"}]]

const IconLetterJSmall = createReactComponent('outline', 'letter-j-small', 'LetterJSmall', __iconNode);

export default IconLetterJSmall;